// extracted by mini-css-extract-plugin
export default {"price":"SY-z","onSale":"TY-z","msrpLabelPrice":"UY-z","originalPrice":"VY-z","msrpLabel":"WY-z","percentOff":"XY-z"};